import type { HITLConfig } from '../../tool-config-types';
import type { AttackerToolInput } from './types';

export const attackerHitlConfig: HITLConfig = {
  extractData: (args: Record<string, unknown>): AttackerToolInput[] => {
    return [
      {
        signalId: String(args.signalId || ''),
        endpointId: args.endpointId ? String(args.endpointId) : undefined,
        harEntryId: args.harEntryId ? String(args.harEntryId) : undefined,
        credentialId: args.credentialId ? String(args.credentialId) : undefined,
        userNotes: args.userNotes ? String(args.userNotes) : undefined,
        userAttackPrompt: String(args.userAttackPrompt || ''),
        mode: (args.mode as 'awaited' | 'detached' | undefined) ?? undefined,
      },
    ];
  },

  wrapEditedData: (data: unknown[]): Record<string, unknown> => {
    const attackerInput = (data[0] as AttackerToolInput) || {
      signalId: '',
      userAttackPrompt: '',
    };

    const result: Record<string, unknown> = {
      signalId: attackerInput.signalId,
      userAttackPrompt: attackerInput.userAttackPrompt,
    };

    if (attackerInput.mode) {
      result.mode = attackerInput.mode;
    }
    if (attackerInput.endpointId) {
      result.endpointId = attackerInput.endpointId;
    }
    if (attackerInput.harEntryId) {
      result.harEntryId = attackerInput.harEntryId;
    }
    if (attackerInput.credentialId) {
      result.credentialId = attackerInput.credentialId;
    }
    if (attackerInput.userNotes) {
      result.userNotes = attackerInput.userNotes;
    }

    return result;
  },
};
